import { Input } from '@/components/ui/input';

/**
 * Grade de 12 caixinhas "Mês N" pra editar percentuais mensais — nasceu no
 * gerenciamento de usuários (fluxo de repasse) e virou o padrão da casa pra
 * TODO fluxo percentual (o de recebimento da Servopa em Configurações usa o
 * mesmo, a pedido do usuário em 2026-08-25).
 */
export const PaymentScheduleEditor = ({
  value,
  onChange,
  disabled = false,
  helpText = 'Porcentagem da produção paga ao vendedor em cada mês.',
}: {
  value: readonly number[];
  onChange: (next: number[]) => void;
  disabled?: boolean;
  helpText?: string;
}) => {
  const updateMonth = (idx: number, raw: string) => {
    if (disabled) return;
    const parsed = raw === '' ? 0 : Number(raw.replace(',', '.'));
    if (!Number.isFinite(parsed) || parsed < 0) return;
    const next = value.slice();
    next[idx] = parsed;
    onChange(next);
  };
  const total = value.reduce((acc, n) => acc + (Number.isFinite(n) ? n : 0), 0);
  return (
    <div className={disabled ? 'opacity-50' : undefined}>
      <div className="text-xs text-muted-foreground mb-2">
        {helpText}
      </div>
      <div className="grid grid-cols-6 gap-2">
        {value.map((v, idx) => (
          <div key={idx} className="flex flex-col gap-0.5">
            <span className="text-[10px] text-muted-foreground text-center">Mês {idx + 1}</span>
            <Input
              type="number"
              inputMode="decimal"
              min="0"
              step="0.01"
              value={v}
              disabled={disabled}
              onChange={(e) => updateMonth(idx, e.target.value)}
              className="text-center h-8 px-1 text-xs"
            />
          </div>
        ))}
      </div>
      <div className="text-xs text-muted-foreground mt-2 text-right">
        Total: <span className="font-mono">{total.toFixed(2)}%</span>
      </div>
    </div>
  );
};

